import React from 'react';

const ValidationStep = ({ icon, text, status, isFirst }) => {
  return (
    <>
      <div className={`validation-step ${status}`}>
        <div className="validation-step-content">
          <div className="validation-icon">{icon}</div>
          <div className="validation-text">{text}</div>
        </div>
      </div>
      {isFirst && <div className="connector">—</div>}
    </>
  );
};

export default ValidationStep;
